// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

const companyID = JSON.parse(localStorage.getItem('companyID'))

export const getExpenseType = createAsyncThunk('tagreference/getExpenseTypeList', async () => {
     
  const response = await axios.post('https://api.zasway.com:8443/Common/GetExpenseTypeList')
  return response.data
})

export const getTagType = createAsyncThunk('tagreference/GetTagTypeList', async () => {
     
  const response = await axios.post('https://api.zasway.com:8443/Common/GetTagTypeList')
  return response.data
})


export const getData = createAsyncThunk('tagreference/getData', async (params) => {
            
  const response = await axios.post('https://api.zasway.com:8443/Tag/GetTableSummary', params, {mode:'cors'})
   
  return {
  params,
  data: response.data.data,
  allData: response.data.allData,
  totalPages: response.data.total
  }
})

export const addTagReference = createAsyncThunk('tagreference/Create',  async (Tag, {dispatch}) => {
  
  const response = await axios.post('https://api.zasway.com:8443/Tag/Create', Tag, {mode:'cors'})
  await dispatch(getData({
    companyID, 
    userID: 0, 
    id: 0, 
    page: 0, 
    perPage: 10
  }))
return response
})

export const editTagReference  = createAsyncThunk('tagreference/editTagReference', async (Tag) => {
      
  const response = await axios.post('https://api.zasway.com:8443/Tag/Update', Tag, {mode:'cors'})
  return response
})

 export const getreferenceTag = createAsyncThunk('tagreference/getreferenceTag', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Tag/GetTableSummary', params, {mode:'cors'})
  return {
    params,
    data: response.data.data, 
    allData: response.data.allData,
    totalPages: response.data.total
  }
  })

  export const resetreferenceTagEditData = createAsyncThunk('tagreference/resetreferenceTagEditData', async () => {
     
    return {data:[]}
  })

  export const getreferenceTagEditData = createAsyncThunk('tagreference/getreferenceTagEditData', async (params) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Tag/GetTableSummary', params, {mode:'cors'})
    return {data:response.data.data}
  })

  export const EditreferenceTag = createAsyncThunk('tagreference/Update', async (Tag) => {
    const response = await axios.post('https://api.zasway.com:8443/Tag/Update', Tag, {mode:'cors'})
    return response
})

  export const deletereferenceTag = createAsyncThunk('tagreference/Delete', async (id, { dispatch, getState }) => {
    
    const response = await axios.post('https://api.zasway.com:8443/Tag/Delete', id, {mode:'cors'})
     
    await dispatch(getData(getState().ReferenceTag.params))
    
    return response
})

  export const TagReferenceSlice = createSlice({
    name: 'tagreference',
    initialState: {
      data: [],
      total: 1,
      params: {},
      allData: [],
      selectedUser: null,
      referenceTagEditData: []
    },
    reducers: {},
  extraReducers: builder => {
    builder
    .addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
      state.params = action.payload.params
  })
      .addCase(getreferenceTag.fulfilled, (state, action) => {
         
        state.data = action.payload.data
        state.params = action.payload.params
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
      })
      .addCase(getreferenceTagEditData.fulfilled, (state, action) => {
        
        state.referenceTagEditData = action.payload.data
      })
      .addCase(resetreferenceTagEditData.fulfilled, (state, action) => {
             
        state.referenceTagEditData = action.payload.data
      })
    }
  })

  export default TagReferenceSlice.reducer